<script lang="ts" setup>
import { watch, ref } from 'vue';
import type { IImportValue } from '../IImportValue';
import { InputText } from '@/components';
import type { IEditorComponent } from '@/objects/gui';

const props = defineProps<{
    modelValue: IImportValue;
}>();

// The ref of the input element to focus
const inputref = ref<HTMLInputElement | null>(null);

// Define the model
const model = ref(props.modelValue);

// Define the emits
const emits = defineEmits<{ (e: 'update:modelValue', value: IImportValue): void }>();

// Wathc for modelchanges and then emit the update
watch(
    () => model.value,
    () => {
        emits('update:modelValue', { Value: model.value.Value, Status: '', StatusType: 'na', RowId: model.value.RowId });
    },
);

// Expose the focus method and the validate message
defineExpose<IEditorComponent>({ focus: () => inputref.value?.focus(), validateMessage: ref(null) });
</script>

<template>
    <InputText
        ref="inputref"
        v-model="model.Value"
        :selectOnFocus="true"
    ></InputText>
</template>
